import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';
import './styles.scss';
import Tests from './Tests';
import Notification from './notification';
import Config from './Config';

class ControlPanel extends React.Component {
	constructor() {
		super();

		this.state = {
			activeTab: 'tests',
		};
	}

	render() {
		const {activeTab} = this.state;
		const {isSuperAdmin} = this.props;

		return (
			<div className="lit-users lit-control-panel">
				<div>
					<nav>
						<a
							href="#"
							className={activeTab === 'tests' ? 'tablink1-active' : 'tablink1'}
							onClick={() => this.setState({activeTab: 'tests'})}
						>
							{strings.controlPanel.testerTab}
						</a>
						<a
							href="#"
							className={activeTab === 'notification' ? 'tablink2-active' : 'tablink2'}
							onClick={() => this.setState({activeTab: 'notification'})}
						>
							{strings.controlPanel.aviseringarTab}
						</a>
						{isSuperAdmin && (
							<a
								href="#"
								className={activeTab === 'config' ? 'tablink3-active' : 'tablink3'}
								onClick={() => this.setState({activeTab: 'config'})}
							>
								{strings.controlPanel.configurations}
							</a>
						)}
					</nav>
				</div>
				{activeTab === 'tests' && <Tests />}
				{activeTab === 'notification' && <Notification />}
				{activeTab === 'config' && isSuperAdmin && <Config />}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {currentUser} = state;
	return {
		isSuperAdmin: currentUser?.isSuperAdmin || false,
	};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ControlPanel);
